import AgentCardHeader from './AgentCardHeader';
import AgentCardTeam from './AgentCardTeam';
import LoadMore from './LoadMore';
import React, { useState } from 'react';
import useTheme from '../../../../Hooks/Shared/useTheme/useTheme';

const COUNT = 3;

/** @returns {JSX.Element | null} */
export default function AgentCard() {
	const { agentId, teamList } = useTheme();
	const [visibleCount, setVisibleCount] = useState(COUNT);

	if (!agentId) {
		return null;
	}

	return (
		<section className="card card-contact pb-3">
			<AgentCardHeader />

			<section className="px-10 text-lg">
				{teamList?.slice(0, visibleCount).map((member) => (
					<AgentCardTeam key={member.email} member={member} />
				))}
			</section>

			<LoadMore
				loadMore={visibleCount < teamList?.length}
				onClick={() => setVisibleCount(visibleCount + COUNT)}
			/>
		</section>
	);
}
